import type { IconProps } from "./icon-types";

/**
 * 채운 원 안 정립 "i" — info/안내 상태 표시. `InfoIcon`의 채움 변형.
 * 면은 `currentColor`로 채우고 기호는 `text.onStatus`(테마 밖 fallback 흰색)로 얹는다. 선 버전과 같은
 * c6 자체 기하의 채움 변형 — 알림처럼 아이콘이 tone을 전달해야 하는 자리용.
 */
export const InfoFilledIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <circle cx="8" cy="8" r="7" />
    <circle cx="8" cy="5" r="1" fill="var(--c6-color-text-on-status, #ffffff)" />
    <path
      d="M8 7.5v4"
      fill="none"
      stroke="var(--c6-color-text-on-status, #ffffff)"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
